import { Flex, Text } from "@/atoms"
import { PlatformField } from "./PlatformField"

import type { DetectionFieldProps } from "./LiveRuleField.types"

export const DetectionField = ({ name, label, help }: DetectionFieldProps) => (
  <Flex vertical>
    {label}
    {help && (
      <Text type="secondary" className="sm-text-ks">
        {help}
      </Text>
    )}
    <PlatformField name={name} />
  </Flex>
)
